export const getGapAnalysisLocalStorageKey = (
    userId: Maybe<string>,
    entityId: Maybe<string>,
): string =>
    `gapAnalysisContext.user:${userId ?? '__unknown_user__'}.entity:${
        entityId ?? '__unknown_entity__'
    }`;
